const APPLICANT_KIND_SEPARATOR = ':';

export const isConnectionStepHidden = (
	filters: readonly string[] | undefined,
	connectionKind: string,
	applicantKind: string | undefined,
): boolean => {
	if (!filters?.length) {
		return false;
	}

	return filters.some((filter) => {
		const [filterConnectionKind, filterApplicantKind] = filter.split(APPLICANT_KIND_SEPARATOR);
		if (filterConnectionKind !== connectionKind) {
			return false;
		}
		if (filterApplicantKind === undefined) {
			return true;
		}
		return filterApplicantKind === applicantKind;
	});
};
